export enum FileSaverUsecase {
    EXCEL_EXPORT_ERZEUGUNGSANLAGEN,

    CSV_EXPORT_ERZEUGUNGSANLAGEN,
    CSV_EXPORT_NETZBETREIBER,
    CSV_EXPORT_NETZZUORDNUNGEN,
    CSV_EXPORT_PLANWERTE
}
